"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadLayer = void 0;
const registry_call_1 = require("./registry-call");
const contentTypes = require("./content-types");
const options_1 = require("./options");
/**
 * Downloads a layer blob and streams it to a file.
 *
 * Retrieves a container image layer blob and writes it directly to the specified file path.
 * This is the recommended method for downloading large layers as it streams the content
 * to disk rather than loading it entirely into memory, providing better performance and
 * preventing memory exhaustion issues.
 *
 * OCI Distribution Specification endpoint: `/v2/<name>/blobs/<digest>`
 *
 * @param output - File path where the layer blob will be written
 * @param registryBase - The base URL of the container registry
 * @param repo - The repository name (e.g., "library/nginx")
 * @param digest - The layer blob digest (e.g., "sha256:abc123...")
 * @param username - Optional username for authentication
 * @param password - Optional password for authentication
 * @param options - Optional request configuration options (acceptLayer can customize content type)
 * @param observer - Optional observer to record client events
 *
 * @returns HTTP response object (headers and status, body is excluded as it's written to file)
 *
 * @throws {NeedleWrapperException} When blob not found or HTTP errors occur
 * @throws {Error} When file write operations fail
 */
async function downloadLayer(output, registryBase, repo, digest, username, password, options = {}, observer) {
    var _a;
    const cloned = (0, options_1.cloneOptions)(options);
    const accept = `${(_a = cloned.acceptLayer) !== null && _a !== void 0 ? _a : contentTypes.LAYER}`;
    const endpoint = `/${repo}/blobs/${digest}`;
    const layerResponse = await (0, registry_call_1.registryV2Call)(registryBase, endpoint, accept, username, password, cloned, observer, { kind: "streamed", outputPath: output });
    return layerResponse;
}
exports.downloadLayer = downloadLayer;
//# sourceMappingURL=download-layer.js.map